var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Panel',{attrs:{"title":_vm.headerTitle}},[_c('work-hours',{attrs:{"data":_vm.data,"disabled":_vm.disabled},on:{"built-days-of-week":_vm.builtDaysOfWeek}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }